import React from 'react'
import Button from '../button'


export default ({loading, onClick, ...props}) => (
  <Button loading={loading} onClick={(...args) => {
    if(loading) {

    } else if(onClick) {
      onClick(...args);
    }
  }} {...props}>{ props.children }</Button>
)